import { defineStore } from "pinia";
import { useCommonStore } from "@/stores/common";
import {useUserStore} from "@/stores/user"

export const usePatientStore = defineStore("patient", {
  state: () => ({
    
  }),
  actions: {
    // 创建患者
    create(patient) {
      return new Promise(async function(resolve, reject) {
        try {
          const commonStore = useCommonStore();
          let res = await commonStore.createData(patient);
          resolve(res);
        } catch (error) {
          reject(error);
        }
      });
    },
    // 当前患者列表
    index: async (hospital) => {
      return new Promise(async function(resolve, reject) {
        try {
          const commonStore = useCommonStore();
          const patientStore = usePatientStore();
          let res = []
          if(hospital){
            res = await commonStore.gethospitals(hospital);
          }else{
            res = await commonStore.getDataList();
          }
         
          console.log("index", res.data);
          let result = res.data;
          // 更新每一位患者是否入选，是否排除的标记
          result.forEach((record) => {
            // 处理病理复核状态，同步 isExclude 字段
            if (record.fields["pathologyReview"]) {
              if (record.fields["pathologyReview"] === "复核排除") {
                record.isExclude = 1;
              } else if (["复核确认", "复核待确认", "未复核", "NA"].includes(record.fields["pathologyReview"])) {
                record.isExclude = 0;
              }
            }

            // 病理复核非排除时，根据排除标准同步 isExclude
            if (record.fields["pathologyReview"] !== "复核排除" && record.fields["排除标准"]) {
              if (record.fields["排除标准"]["极早期患者"] !== "是") {
                const excludeFields = [
                  "Budd-Chiari 综合征",
                  "先天性肝纤维化",
                  "结节病",
                  "肝窦阻塞综合征（SOS）",
                  "是否存在肝紫癜病？",
                  "是否有骨髓移植史？",
                  "是否有肝活检诊断为肝血吸虫病（孤立阳性血清学不是排除标准）？",
                  "是否有心力衰竭或行Fontan手术？",
                  "是否有Abernethy综合征？",
                  "是否有遗传性出血性毛细血管扩张？",
                  "是否有慢性胆汁淤积性疾病？（如PBC、PSC）",
                  "是否有恶性肿瘤肝脏浸润？",
                  "是否有淀粉样变？",
                  "α1 抗胰蛋白酶缺乏症及肝豆状核变性等遗传代谢性肝脏疾病",
                  "研究者认为不适合参加本研究的患者"
                ];
                if (excludeFields.some(key => record.fields["排除标准"][key] === "是")) {
                  record.isExclude = 1;
                }
              }
            }

            // 入选标准
            if (record.fields["入选标准"] && record.fields["入选标准"]["入选标准：极早期患者"] == '是') {
               // 是否入选
               record.fields["入选标准"]["是否入选"] = "是";
            }else if (record.fields["入选标准"] && record.fields["入选标准"]["入选标准：肝活检排除肝硬化"]) {
              // 是否满足 1+2
              record.fields["入选标准"]["满足1+2"] = (record.fields["入选标准"]["入选标准：肝活检排除肝硬化"] === "是" && record.fields["入选标准"]["入选标准：临床存在特异性门脉高压征象"] === "是") ? "是" : "否";
              // 是否满足 1+4
              record.fields["入选标准"]["满足1+4"] = (record.fields["入选标准"]["入选标准：肝活检排除肝硬化"] === "是" && record.fields["入选标准"]["入选标准：组织学表现为特异性PSVD"] === "是") ? "是" : "否";
              // 是否满足 1+3+5
              record.fields["入选标准"]["满足1+3+5"] = (record.fields["入选标准"]["入选标准：肝活检排除肝硬化"] === "是" && record.fields["入选标准"]["入选标准：临床存在非特异性门脉高压征象"] === "是" && record.fields["入选标准"]["入选标准：组织学表现为非特异性"] === "是") ? "是" : "否";
              // 是否入选
              record.fields["入选标准"]["是否入选"] = (record.fields["入选标准"]["满足1+2"] === "是" || record.fields["入选标准"]["满足1+4"] === "是" || record.fields["入选标准"]["满足1+3+5"] === "是") ? "是" : "否";
            }

            // 是否排除
            if (record.fields["排除标准"] && record.fields["排除标准"]['极早期患者'] == '是') {
              record.fields["排除标准"]["是否排除"] = "否";
            }else if (record.fields["排除标准"] && record.fields["排除标准"]["Budd-Chiari 综合征"]) {

              record.fields["排除标准"]["是否排除"] = "否";
              [
                "Budd-Chiari 综合征",
                "先天性肝纤维化",
                "结节病",
                "肝窦阻塞综合征（SOS）",
                "是否存在肝紫癜病？",
                "是否有骨髓移植史？",
                "是否有肝活检诊断为肝血吸虫病（孤立阳性血清学不是排除标准）？",
                "是否有心力衰竭或行Fontan手术？",
                "是否有Abernethy综合征？",
                "是否有遗传性出血性毛细血管扩张？",
                "是否有慢性胆汁淤积性疾病？（如PBC、PSC）",
                "是否有恶性肿瘤肝脏浸润？",
                "是否有淀粉样变？",
                "α1 抗胰蛋白酶缺乏症及肝豆状核变性等遗传代谢性肝脏疾病",
                "研究者认为不适合参加本研究的患者"
              ].forEach((key) => {
                if (["是", "有"].includes(record.fields["排除标准"][key])) {
                  record.fields["排除标准"]["是否排除"] = "是";
                }
              });
            }
          });
          resolve(result);
        } catch (error) {
          reject(error);
        }
      });
    },
    // 获取患者死亡的访视期（返回死亡访视期的type，如果未死亡返回null）
    getDeathPeriod: (patientRow) => {
      try {
        // 定义所有访视期的顺序
        const visitPeriods = [
          "筛选期（肝穿前96周内资料完整点）±2周",
          "V0肝穿点±2周",
          "访视期V1（肝穿后24周）",
          "访视期V2（肝穿后48周）",
          "访视期V3（肝穿后72周）",
          "访视期V4（肝穿后96周）",
          "访视期V5（肝穿后120周）",
          "访视期V6（肝穿后144周）",
          "访视期V7（肝穿后168周）",
          "访视期V8（肝穿后192周）",
          "访视期V9（肝穿后216周）",
          "访视期V10（肝穿后240周）"
        ];
        
        // 检查普通访视期
        for (const period of visitPeriods) {
          const periodData = patientRow.fields[period];
          if (periodData) {
            // 检查转归字段是否包含"死亡"
            if (periodData['转归'] && Array.isArray(periodData['转归']) && periodData['转归'].includes('死亡')) {
              return period;
            }
            // 检查不良事件记录中的死亡字段
            if (periodData['门高压并发症_死亡'] === '是') {
              return period;
            }
          }
        }
        
        // 检查计划外访视
        if (patientRow.fields.jhw && Array.isArray(patientRow.fields.jhw)) {
          for (const jhwItem of patientRow.fields.jhw) {
            // 计划外访视的实际数据存储在 fields[jhwItem.type] 中
            const jhwData = patientRow.fields[jhwItem.type];
            if (jhwData) {
              // 检查转归字段是否包含"死亡"
              if (jhwData['转归'] && Array.isArray(jhwData['转归']) && jhwData['转归'].includes('死亡')) {
                return jhwItem.type;
              }
              // 检查不良事件记录中的死亡字段
              if (jhwData['门高压并发症_死亡'] === '是') {
                return jhwItem.type;
              }
            }
          }
        }
        
        return null;
      } catch (error) {
        return null;
      }
    },
    // 判断患者是否死亡
    isDead: (patientRow) => {
      const patientStore = usePatientStore();
      return patientStore.getDeathPeriod(patientRow) !== null;
    },
    // 判断某个访视期是否应该显示（死亡后的访视期不显示）
    shouldShowVisit: (patientRow, visitType) => {
      try {
        const patientStore = usePatientStore();
        const deathPeriod = patientStore.getDeathPeriod(patientRow);
        
        // 如果患者没有死亡，显示所有访视期
        if (!deathPeriod) {
          return true;
        }
        
        // 入选标准和排除标准始终显示
        if (['入选标准', '排除标准'].includes(visitType)) {
          return true;
        }
        
        // 定义访视期顺序（用于比较先后）
        const visitOrder = [
          "筛选期（肝穿前96周内资料完整点）±2周",
          "V0肝穿点±2周",
          "访视期V1（肝穿后24周）",
          "访视期V2（肝穿后48周）",
          "访视期V3（肝穿后72周）",
          "访视期V4（肝穿后96周）",
          "访视期V5（肝穿后120周）",
          "访视期V6（肝穿后144周）",
          "访视期V7（肝穿后168周）",
          "访视期V8（肝穿后192周）",
          "访视期V9（肝穿后216周）",
          "访视期V10（肝穿后240周）"
        ];
        
        // 获取当前访视期和死亡访视期的索引
        const currentIndex = visitOrder.indexOf(visitType);
        const deathIndex = visitOrder.indexOf(deathPeriod);
        
        // 如果是计划外访视，需要特殊处理
        if (currentIndex === -1) {
          // 当前是计划外访视
          if (deathIndex === -1) {
            // 死亡也在计划外，需要比较计划外的时间
            // 由于计划外访视已经按时间排序，这里简单比较type字符串
            return visitType <= deathPeriod;
          } else {
            // 死亡在普通访视期，计划外访视按时间判断
            // 这里需要从patientRow获取计划外访视的时间
            const jhwItem = patientRow.fields.jhw?.find(item => item.type === visitType);
            if (jhwItem && jhwItem.time) {
              // 获取死亡访视期的时间
              const deathPeriodData = patientRow.fields[deathPeriod];
              const deathTime = deathPeriodData?.['访视日期'] || '';
              return jhwItem.time <= deathTime;
            }
          }
        }
        
        // 如果死亡在计划外访视
        if (deathIndex === -1) {
          // 死亡在计划外，需要比较时间
          const jhwItem = patientRow.fields.jhw?.find(item => item.type === deathPeriod);
          if (jhwItem && jhwItem.time) {
            // 获取当前访视期的时间
            const currentPeriodData = patientRow.fields[visitType];
            const currentTime = currentPeriodData?.['访视日期'] || '';
            return currentTime <= jhwItem.time;
          }
        }
        
        // 都是普通访视期，比较索引
        return currentIndex <= deathIndex;
      } catch (error) {
        return true; // 出错时默认显示
      }
    },
    // 判断是否可以填写筛选期和访视期表（优先级：病理复核排除 > 入选/排除标准）
    // 注意：死亡患者的死亡访视期及之前的访视期仍然可以查看，死亡后的访视期通过shouldShowVisit隐藏
    isFill: (patientRow) => {
      // 1. 优先检查病理复核是否为排除，如果是则不能填写
      if (patientRow.isExclude === true || patientRow.isExclude === 1 || patientRow.isExclude === '1') {
        return false;
      }
      
      // 2. 病理复核不是排除，再按原逻辑判断
      return patientRow && (patientRow.fields["入选标准"]?.['入选标准：极早期患者'] == '是' &&
        patientRow.fields["排除标准"]?.["极早期患者"]  == '是') ||
        (patientRow.fields["入选标准"] &&
        patientRow.fields["入选标准"]["是否入选"] &&
        patientRow.fields["入选标准"]["是否入选"] === "是" &&
        patientRow.fields["排除标准"] &&
        patientRow.fields["排除标准"]["是否排除"] &&
        patientRow.fields["排除标准"]["是否排除"] === "否");
    },
    // 判断是否符合入选标准
    isIn: (patientRow) => {
      try {
        // 满足 1+2，或者 1+4，或者 1+3+5
        return patientRow.fields["入选标准"]["是否入选"] === "是";
      } catch (error) {
        return null;
      }
    },
    // 判断是否符合排除标准（包括病理复核排除和排除标准排除）
    isOut: (patientRow) => {
      try {
        // 1. 检查病理复核是否为排除
        if (patientRow.isExclude === true || patientRow.isExclude === 1 || patientRow.isExclude === '1') {
          return true;
        }
        // 2. 检查排除标准是否为排除
        return patientRow.fields["排除标准"]["是否排除"] === "是";
      } catch (error) {
        return null;
      }
    }
  }
});
